import { useSelector } from "react-redux";

const EmployeeAppLogs = () => {

  return (
    <>
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iiplwork.retool.com/embedded/public/0774754c-bc45-4c53-844c-357ba4b553be"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default EmployeeAppLogs;
